import { notificationRenderers } from "./constants";
import DefaultRenderer from "./components/DefaultRenderer";

const NotificationRenderer = ({ notification, classes }) => {
  const Component = notificationRenderers[notification.action];

  if (!Component) {
    return <DefaultRenderer notification={notification} classes={classes} />;
  }

  return <Component notification={notification} classes={classes} />;
};

export default NotificationRenderer;
